import {Injectable} from '@angular/core';
import {ConfigService} from '../web/config.service';
import {InactivityService} from '../web/inactivity.service';
import {HttpService} from './http.service';
import {StorageService} from '../web/storage.service';
import {IamApiBaseService} from './iam-api-base.service';
import {NotificationService} from '../web/notification.service';

@Injectable({
  providedIn: 'root'
})
export class EdpApiService extends IamApiBaseService{
  constructor(
    httpService: HttpService,
    configService: ConfigService,
    inactivityService: InactivityService,
    storageService: StorageService,
    notificationService: NotificationService
  ) {
    super(httpService, configService, inactivityService, storageService, notificationService);
    this.basePath = configService.getConfig().edpPath;
  }
}
